import { css, cva } from '@/styled-system/css';

// Advertising-cell state chip. Three tones: static (manage-in-feed), disabled (not eligible),
// and interactive (the dropdown trigger, with hover affordance).
export const chipRecipe = cva({
  base: {
    display: 'inline-flex',
    alignItems: 'center',
    gap: '100',
    boxSizing: 'border-box',
    // oxlint-disable-next-line constellation/no-raw-spacing-values
    width: '11rem',
    // oxlint-disable-next-line constellation/no-raw-spacing-values
    height: '24px',
    paddingInline: '200',
    borderRadius: '{radii.shape.capsule}',
    borderStyle: 'solid',
    borderWidth: '1px',
    borderColor: '{colors.border.action.neutral.default}',
    backgroundColor: '{colors.bg.action.neutral.default}',
  },
  variants: {
    tone: {
      static: {},
      disabled: { opacity: 0.6 },
      interactive: {
        justifyContent: 'space-between',
        cursor: 'pointer',
        transition: 'border-color 200ms ease, background-color 200ms ease',
        _hover: {
          backgroundColor: '{colors.bg.action.neutral.hover}',
          borderColor: '{colors.border.action.neutral.hover}',
        },
      },
    },
  },
  defaultVariants: {
    tone: 'static',
  },
});

// Truncation for the chip label so it never breaks the fixed chip width.
export const chipLabelStyle = css.raw({
  flex: 1,
  minWidth: 0,
  overflow: 'hidden',
  textOverflow: 'ellipsis',
  whiteSpace: 'nowrap',
});
